import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'move-record',
  templateUrl: './move-record.component.html',
  styleUrls: ['./move-record.component.less'],
})
export class MoveRecordComponent implements OnInit, OnChanges {
  @Input() data: Array<object> = [];
  date: Array<string> = [];
  listOfData: object = {};
  @Input() keys: object = {
    organ_name: '公司名称',
    short_title: '公司简称',
    address: '详细地址',
    status_name: '营业状态',
    longitude: '定位坐标',
    area_name: '省市区',
    area_id: '省市区',
    province_id: '省市区',
    city_id: '省市区',
  }; // key名称对照字段
  @Input() specialKeys: Array<string> = [
    'area_id',
    'province_id',
    'city_id',
    'longitude',
    'work_starttime',
    'thumb',
    'area_name',
    'city_name',
    'province_name',
    'longitude',
  ]; // 特殊处理字段
  objectKeys = Object.keys;
  showFull = [];
  @Output() clickItem = new EventEmitter;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] != undefined) {
      if (this.data.length > 0) {
        this.dealRecordData(this.data);
      } else {
        this.date = [...[]];
        this.listOfData = { ...{} };
      }
    }
  }

  dealRecordData(data: any): void {
    const result = {};
    const date = [];
    let itemDate = '';
    let key = '';
    data.map((item) => {
      // 处理时间显示格式
      itemDate = item['record_apply_time'].substr(0, 10).split('/');
      key = itemDate[0] + '年' + itemDate[1] + '月' + itemDate[2] + '日';
      if (result[key] == undefined) {
        result[key] = [];
        date.push(key);
      }
      result[key].push(item);
    });
    this.date = [...date];
    this.listOfData = { ...result };
  }

  /**
   * 点击展示详细异动情况
   * @param item
   */
  showDetails(item: any): void {
    this.clickItem.emit({ event: 'click', target: { details: item } });
  }
}
